import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from '../../../models/response/base-response';
import { actions } from '../../actions/actionsWrapper';
import { IConCbnv } from '../../../models/response/hoc-sinh/IConCbnv';
import { eConCbnvActionTypeIds, IConCbnvActionTypes } from '../../action-types/con-cbnv/IConCbnvActionTypes';
import { IHocSinhAceChiTietLoadStart } from '../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart';


export function* conCbnvSaga(): any {
    yield takeLatest(eConCbnvActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eConCbnvActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eConCbnvActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(action: IConCbnvActionTypes): any {
    const payload: IHocSinhAceChiTietLoadStart = action.payload as IHocSinhAceChiTietLoadStart;

    const res: IBaseResponeModel = yield call(apiWrapper.conCbnv.select_all_by_hocsinh, payload)
    if (res.is_success) {
        yield put(actions.conCbnv.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.conCbnv.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IConCbnvActionTypes): any {
    const payload: IConCbnv = action.payload as IConCbnv;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.conCbnv.update, payload)
    } else {
        res = yield call(apiWrapper.conCbnv.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.conCbnv.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.conCbnv.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IConCbnvActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.conCbnv.delete, payload)
    if (res.is_success) {
        yield put(actions.conCbnv.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.conCbnv.DELETE_ERROR(res.message ?? "Error"))
    }
}
